/**
 * Polling-Konfiguration für den Status-Loop (AFO-013 / DEV-017).
 *
 * - `POLL_INTERVAL_MS`: Pause zwischen zwei `fetchStatus`-Aufrufen.
 * - `MAX_POLL_ATTEMPTS`: Hartes Cap. 18 Versuche × 5 s ≈ 90 s Gesamt-Budget.
 *   Wird das Cap erreicht, bricht der Loop ohne weiteren Request ab und
 *   meldet `TECHNICAL_ERROR` Variante `generic`.
 */
export const POLL_INTERVAL_MS = 5_000;
export const MAX_POLL_ATTEMPTS = 18;

/**
 * Transiente Poll-Fehler (T-9): kurze Netzaussetzer werden bis zu dieser
 * Anzahl **in Folge** wiederholt (Zähler resettet bei jedem erfolgreichen
 * Tick); ein 429 wartet die Server-Vorgabe `Retry-After` ab — geklemmt auf
 * das Intervall unten, damit weder ein 0-Sekunden-Header hämmert noch ein
 * absurder Wert das Polling einfrieren kann. `MAX_POLL_ATTEMPTS` bleibt in
 * beiden Fällen die harte Obergrenze.
 */
export const MAX_CONSECUTIVE_NETWORK_RETRIES = 2;
export const RETRY_AFTER_MIN_MS = 1_000;
export const RETRY_AFTER_MAX_MS = 30_000;
